import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import Divider from '@mui/joy/Divider';
import { Dispatch, SetStateAction, useState } from 'react';
import { Intencion } from '../../../types/empresa';
import { useGetUsersForFilterQuery } from '../../../api/filter/dataFilterApi';

interface Props {
    visitaId: number;
    intenciones: Intencion[];
    setIntenciones: Dispatch<SetStateAction<Intencion[]>>;
}

export function AddIntenciones({ visitaId, intenciones, setIntenciones }: Props) {
    const [vendedorSelected, setVendedorSelected] = useState<number>(0);
    const [totalIntenciones, setTotalIntenciones] = useState<number>(0);
    const [addIntencionError, setAddIntencionError] = useState<string | null>(null);

    const { data: vendedores } = useGetUsersForFilterQuery({
        role: "Vendedor",
        dealId: visitaId.toString(),
        type: "include"
    });

    const addIntencion = () => {
        setAddIntencionError(null);

        if(vendedorSelected === 0) {
            setAddIntencionError("Debe seleccionar un vendedor")
            return;
        }

        // valida que no se agregue el mismo vendedor dos veces
        if(intenciones.find((intencion) => intencion.vendedorId == vendedorSelected)) {
            setAddIntencionError("Este vendedor ya esta en agregado")
            return;
        }

        const vendedor = vendedores?.find((vendedor) => vendedor.id === vendedorSelected);

        const intencion: Intencion = {
            vendedorName: vendedor?.nombre ?? "Sin nombre",
            vendedorId: vendedorSelected,
            numIntenciones: totalIntenciones,
        };
        setIntenciones([...intenciones, intencion]);

        // clear inputs
        setVendedorSelected(0);
        setTotalIntenciones(0);
    }

    const deleteIntencion = (index: number) => {
        intenciones.splice(index, 1);

        setIntenciones([...intenciones]);
    }

    return (
        <div className="mt-4 flex flex-col flex-1 overflow-hidden">
            <Divider><p className="text-sm font-semibold">Intenciones</p></Divider>

            <p className="text-sm font-semibold">Agregar ventas</p>
            <div className="flex items-center gap-x-2">
                <select
                    value={vendedorSelected}
                    onChange={(event) => {
                        const vendedorId = parseInt(event.target.value);

                        if(isNaN(vendedorId))
                            return;

                        setVendedorSelected(vendedorId);
                    }}
                    className="
                        flex-1 h-[26px] rounded-[3px] border-gray-400 border my-1 px-2 
                        font-semibold text-gray-600 text-sm">
                    <option value={0} hidden>Seleccionar vendedor</option>
                    {vendedores?.map((vendedor, index) => (
                    <option value={vendedor.id} key={index}>{vendedor.nombre}</option>
                    ))}
                </select>
                <input 
                    className="
                        w-[60px] h-[26px] rounded-[3px] border-gray-400 border my-1 px-2 
                        font-semibold text-gray-600 text-sm"
                    value={totalIntenciones.toString()}
                    onChange={(event) => {
                        if(event.target.value == "") {
                            setTotalIntenciones(0);
                            return ;
                        }

                        const intenciones = parseInt(event.target.value);

                        if(isNaN(intenciones) || intenciones < 0)
                            return;

                        setTotalIntenciones(intenciones);
                    }}
                    type="number" />
                <button
                    onClick={addIntencion}
                    type="button"
                    className="bg-slate-700 border-0 border-gray-300 h-[26px] rounded-[3px] px-[6px] py-[2px] flex gap-1 items-center text-sm text-white font-semibold">
                    Agregar
                </button>
            </div>
            {addIntencionError && (
                <p className="valErrorText text-sm">{addIntencionError}</p>
            )}

            <div className="flex flex-col flex-1 overflow-auto my-2">
                {intenciones.length === 0
                ? <p className="text-sm font-semibold text-gray-600 italic text-center">No hay intenciones agregadas</p>
                : intenciones.map((intencion, index) => (
                    <div 
                        key={index}
                        className="flex gap-x-2 justify-between hover:bg-slate-50 p-2 rounded-md">
                        <div className="flex gap-x-1">
                            <div className="w-[20px] h-[20px] bg-gray-500 rounded-full"></div>
                            <p className="text-sm font-semibold">{intencion.vendedorName}</p>
                        </div>
                        <div>
                            <p className="text-sm font-semibold">Intenciones vendidas: {intencion.numIntenciones}</p>
                        </div>
                        <div 
                            className="flex items-center h-[20px] cursor-pointer hover:bg-red-200 rounded-md" 
                            onClick={() => deleteIntencion(index)}>
                            <CloseRoundedIcon sx={{ height: 20, width: 20 }}/>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
